import { GlobalPositionStrategy } from '@angular/cdk/overlay';

export class TellentAssistantPositionStrategy extends GlobalPositionStrategy {
  public override apply(): void {
    super.apply();
    // GlobalPositionStrategy sets `position: static` on the overlay pane; we need `fixed` so the
    // panel stays viewport-anchored. Reach the pane via CDK's private `_overlayRef` field — same
    // pattern as NotificationsPositionStrategy. Recheck on `@angular/cdk` upgrades.
    const pane = this['_overlayRef']?.overlayElement;
    if (pane) {
      pane.style.position = 'fixed';
    }
  }
}
